/**
 * Додаткові параметри при відкритті навігатора
 * Використовують для вибору файлу
 */
const initAddParams = {
    fileTypes   : [],           // Типи файлів 
    showPrivate : false,        // Чи показувати приватні файли
    callBack    : null          // Функція кліка на файлові (в якій передається структура файлу - fileData)
}

 
/**
 * Структура основного стану навігатора
 */
export const initialState = {
    showFN          : false,        // Відкритий навігатор
    currentPathFN   : '',           // Поточна папка навігатор  
    dataFN          : null,         // Стурктура файлів
    selectedFiles   : [],           // Вибрані файли
    copyFiles       : [],           // Файли скопійовані в буфер
    catFiles        : [],           // Файли "вирізані" в буфер
    addParams : {                   // Додаткові параметри
        ...initAddParams                            
    }    
};


/** 
 * 
 * @param {Object} state    - попередній стан
 * @param {Object} action   - обєкт дії
 * @returns 
 */
export function fileNavigatorReducer(state, action) {
    switch (action.type) {

        // Відкриває навігатор (без вибору файлу)
        case 'SET_SHOW_FN':
            return { ...state, 
                        showFN: action.payload,
                    };

        // Ресет додаткових параметрів
        case 'RESET_ADD_PARAM':
            return { ...state, addParams: {
                fileTypes : [] 
            }}

     


        // відкриває навігатор для вибору файлу (використовуються дод. парметри "addParams")
        case 'OPEN_4_SELECT':
            return { ...state, 
                        showFN: true,
                        addParams: {...action.payload}}  
        
        // Задає поточний шлях
        case 'SET_CURRENT_PATH':
            return { ...state, currentPathFN: action.payload, selectedFiles: [] }; // Очищаємо вибрані файли
        
        // Задаємо структуру файлів (всю)
        case 'SET_DATA_FN':
            return { ...state, dataFN: action.payload };
        
        // Відмітка, або зняття відмітки файлу
        case 'TOGGLE_SELECTED':
            const isSelected = state.selectedFiles.includes(action.payload);
            if (action.payload === null) return {...state, selectedFiles:[]};
            return {
                ...state,
                selectedFiles: isSelected
                    ? state.selectedFiles.filter(file => file !== action.payload)
                    : [...state.selectedFiles, action.payload],
            };
        
        // Задає файли для копіювання через буфер
        case 'SET_COPY_FILES':
            return { ...state, copyFiles: action.payload };
        
        // Задає файли для перемщення через буфер
        case 'SET_CAT_FILES':
            return { ...state, catFiles: action.payload };
        
        default:
            return state;
    }
}